export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">关于爆料网</h2>

          <div className="bg-background-50 rounded-lg border border-background-200/60 p-8 md:p-10">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-radar-line text-2xl text-primary-500"></i>
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              爆料网成立于2023年，是国内领先的网红圈八卦娱乐资讯聚合平台。
              我们致力于为吃瓜群众提供最全面、最及时、最可靠的网红八卦黑料信息。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台覆盖直播圈、短视频圈、娱乐圈、电竞圈、电商圈等核心领域，
              拥有专业的编辑团队和遍布全网的投稿人网络。从头部达人的最新动态到行业内部的深度揭秘，
              从日常八卦吃瓜到重大翻车事件的全程追踪，爆料网为你一站式呈现网红圈的真实生态。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们坚持「快速、真实、深度」三大原则：快速响应热点事件，多重核实信息来源，
              深度挖掘八卦背后的行业逻辑。爆料网不仅是吃瓜的第一站，更是理解网红经济的窗口。
            </p>

            <div className="grid grid-cols-3 gap-6 mt-8 pt-6 border-t border-background-200/60">
              <div>
                <div className="text-2xl font-heading text-primary-500">30+</div>
                <div className="text-xs text-foreground-400 mt-1">覆盖平台</div>
              </div>
              <div>
                <div className="text-2xl font-heading text-primary-500">7×24</div>
                <div className="text-xs text-foreground-400 mt-1">全天候更新</div>
              </div>
              <div>
                <div className="text-2xl font-heading text-primary-500">10万+</div>
                <div className="text-xs text-foreground-400 mt-1">忠实读者</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}